import "../src/global/global-mobile"
import "../src/stars/StarsSubscription"
import {
    addEventListenersToMyStarsFilterButtons,
    setNavigationCookieEventListeners,
} from "../src/stars/my-stars/my-stars.ts"

import "@modules/stars/styles.css"
import "@modules/stars/my-stars/mobile.css"
import "@modules/stars/not-logged-in-box.css"
import "@modules/vue-modals/age-verification.js"
import "@modules/vue-modals/coins"

addEventListenersToMyStarsFilterButtons()
setNavigationCookieEventListeners()
